export const constructionQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "Some workers are installing solar panels.",
      B: "A worker is painting the rooftop.",
      C: "Workers are putting on their helmets.",
      D: "A worker is using a welding torch.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자들이 태양광 패널을 설치하고 있음\n" +
      "오답 설명: (B) 페인트칠을 하지 않음, (C) 이미 헬멧을 착용한 상태임, (D) 용접 작업을 하지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "A worker is adjusting his safety helmet.",
      B: "A worker is wearing a safety helmet and gloves.",
      C: "A worker is picking up a tool.",
      D: "A worker is climbing down a ladder.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 작업자가 안전모와 장갑을 착용하고 있음\n" +
      "오답 설명: (A) 안전모를 조정하지 않음, (C) 이미 도구를 잡고 작업 중임, (D) 사다리를 내려오지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "A man is pointing at a blueprint.",
      B: "A woman is using a power drill.",
      C: "A worker is putting on a safety vest.",
      D: "The blueprint is being folded.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남성이 청사진을 가리키고 있음\n" +
      "오답 설명: (B) 전동 드릴을 사용하지 않음, (C) 안전조끼를 입는 중이 아님, (D) 청사진이 펼쳐져 있음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "A man is putting on his tie.",
      B: "A man is picking up the blueprint.",
      C: "Some workers are carrying construction materials.",
      D: "Two men are examining a blueprint.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 두 남자가 청사진을 검토하고 있음\n" +
      "오답 설명: (A) 넥타이를 이미 매고 있음, (B) 청사진을 이미 들고 있음, (C) 건설 자재를 운반하지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "A worker is standing on a lift.",
      B: "A man is coming down from the lift.",
      C: "A worker is adjusting his helmet.",
      D: "A worker is installing a streetlight.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자가 리프트 위에 서 있음\n" +
      "오답 설명: (B) 리프트에서 내려오지 않음, (C) 안전모를 만지지 않음, (D) 가로등을 설치하지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A worker is holding onto a cable.",
      B: "A man is putting on his gloves.",
      C: "A worker is carrying a toolbox.",
      D: "A man is climbing up the cable.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자가 케이블을 잡고 있음\n" +
      "오답 설명: (B) 이미 장갑을 끼고 작업 중임, (C) 공구 상자를 들고 있지 않음, (D) 줄을 잡고 있을 뿐 올라가지 않음",
  },

  {
    questionNumber: 7,
    choices: {
      A: "A worker is wearing a backpack.",
      B: "A worker is reading a manual.",
      C: "A worker is operating a vehicle.",
      D: "A man is putting on his gloves.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 차량을 운전하고 있음\n" +
      "오답 설명: (A) 배낭을 메고 있지 않음, (B) 설명서를 보고 있지 않음, (D) 이미 장갑을 끼고 작업 중임",
  },
  {
    questionNumber: 8,
    choices: {
      A: "A worker is adjusting his helmet.",
      B: "A worker is putting on a safety vest.",
      C: "Two workers are looking at a clipboard.",
      D: "A worker is using a tool to fix a machine.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 두 작업자가 클립보드를 보고 있음\n" +
      "오답 설명: (A) 안전모를 조정하지 않음, (B) 이미 안전조끼를 입고 있음, (D) 공구를 사용하지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "A worker is sweeping the sidewalk.",
      B: "A worker is sitting on a machine.",
      C: "A man is bending over while working.",
      D: "A worker is painting lane markings.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 허리를 구부리고 작업하고 있음\n" +
      "오답 설명: (A) 인도를 쓸고 있지 않음, (B) 기계에 앉아있지 않음, (D) 차선을 그리지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The workers are walking side by side.",
      B: "Traffic cones are being placed on the ground.",
      C: "The workers are placing traffic cones on the road.",
      D: "The workers are picking up traffic cones.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자들이 나란히 걷고 있음\n" +
      "오답 설명: (B) 트래픽콘을 작업자들이 들고 있음, (C) 트래픽콘을 놓고 있지 않음, (D) 트래픽콘을 집어 올리지 않음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "A worker is standing in front of a shelf.",
      B: "A worker is moving boxes by hand.",
      C: "A worker is operating a machine.",
      D: "A man is putting on a face mask.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 기계를 운전하고 있음\n" +
      "오답 설명: (A) 선반 앞에 서 있지 않음, (B) 상자를 손으로 옮기지 않음, (D) 이미 마스크를 쓰고 있음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "A man is dipping a brush in paint.",
      B: "A man is cleaning the wall.",
      C: "The worker is painting a building.",
      D: "The worker is building a platform.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 건물을 페인트칠하고 있음\n" +
      "오답 설명: (A) 이미 브러시로 칠하는 중임, (B) 벽을 청소하지 않고 칠하는 중임, (D) 발판을 설치하지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "The worker is cleaning a window.",
      B: "The worker is painting a wall.",
      C: "The worker is fixing a curtain.",
      D: "A window is being installed.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 창문이 설치되고 있음\n" +
      "오답 설명: (A) 창문을 청소하지 않음, (B) 벽을 칠하지 않음, (C) 커튼을 설치하지 않음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "The man is painting a wooden board.",
      B: "The man is hammering a nail.",
      C: "A piece of wood is being cut.",
      D: "The man is assembling a chair.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 나무 조각이 잘려지고 있음\n" +
      "오답 설명: (A) 페인트칠을 하지 않음, (B) 망치질을 하지 않음, (D) 의자를 조립하지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "The worker is painting the wall.",
      B: "The worker is applying adhesive to the wall.",
      C: "The worker is replacing a broken tile.",
      D: "New tiles are being attached.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 작업자가 벽에 접착제를 바르고 있음\n" +
      "오답 설명: (A) 페인트칠을 하지 않음, (C) 깨진 타일을 교체하지 않음, (D) 아직 타일을 붙이지 않고 접착제만 바르는 중임",
  },
  {
    questionNumber: 16,
    choices: {
      A: "The worker is installing a light fixture.",
      B: "A man is checking the water temperature.",
      C: "The worker is replacing a faucet.",
      D: "The worker is fixing a pipe.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 작업자가 배관을 수리하고 있음\n" +
      "오답 설명: (A) 조명을 설치하지 않음, (B) 물 온도를 확인하지 않음, (C) 수도꼭지를 교체하지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "A man is standing up.",
      B: "A man is breaking down the wall.",
      C: "The worker is repairing electrical wiring.",
      D: "The worker is assembling furniture.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 전기 배선을 수리하고 있음\n" +
      "오답 설명: (A) 작업을 위해 앉아있음, (B) 벽을 허물지 않고 배선을 수리 중임, (D) 가구를 조립하지 않음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "The workers are paving the road.",
      B: "One of the workers is digging with a shovel.",
      C: "The workers are carrying wooden planks.",
      D: "The workers are sitting on a bench.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 한 작업자가 삽으로 땅을 파고 있음\n" +
      "오답 설명: (A) 도로 포장을 하지 않음, (C) 나무 판자를 운반하지 않음, (D) 벤치가 이미지에 없음.",
  },
  {
    questionNumber: 19,
    choices: {
      A: "The worker is shoveling gravel.",
      B: "The man is pushing a wheelbarrow.",
      C: "The workers are standing in a line.",
      D: "A man is painting a wall.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자가 자갈을 삽질하고 있음\n" +
      "오답 설명: (B) 손수레를 밀지 않음, (C) 작업자들이 줄서있지 않음, (D) 벽을 칠하지 않음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "The worker is painting the wall.",
      B: "A man is digging a hole in the ground.",
      C: "The worker is laying bricks.",
      D: "Some workers are assembling scaffolding.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 벽돌을 쌓고 있음\n" +
      "오답 설명: (A) 벽을 칠하지 않음, (B) 땅을 파지 않음, (D) 비계를 조립하지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "The worker is repairing the ceiling.",
      B: "A man is carrying a pile of bricks.",
      C: "The man is standing next to a wheelbarrow.",
      D: "The worker is pushing a wheelbarrow.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 작업자가 손수레를 밀고 있음\n" +
      "오답 설명: (A) 천장을 수리하지 않음, (B) 벽돌을 운반하지 않음, (C) 손수레 옆에 서있지 않음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "The worker is securing a safety harness.",
      B: "A man is installing scaffolding.",
      C: "The worker is transporting construction materials.",
      D: "The man is lifting a wooden plank.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 건설 자재를 운반하고 있음\n" +
      "오답 설명: (A) 안전벨트를 매지 않음, (B) 비계를 설치하지 않음, (D) 나무 판자를 들어올리지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "The worker is paving the road.",
      B: "A man is digging a hole in the ground.",
      C: "The worker is cleaning the machine.",
      D: "A man is carrying a pile of bricks.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 작업자가 도로를 포장하고 있음\n" +
      "오답 설명: (B) 땅을 파지 않음, (C) 기계를 청소하지 않음, (D) 벽돌을 운반하지 않음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "The worker is assembling a metal structure.",
      B: "A man is carrying a wooden ladder.",
      C: "The worker is standing on a ladder.",
      D: "A man is walking on a scaffold.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 사다리 위에 서 있음\n" +
      "오답 설명: (A) 금속 구조물을 조립하지 않음, (B) 사다리를 운반하지 않음, (D) 비계 위를 걷지 않음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "The worker is measuring the wooden board.",
      B: "The man is hammering a nail.",
      C: "A worker is painting the roof.",
      D: "The man is carrying a toolbox.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 못을 망치로 치고 있음\n" +
      "오답 설명: (A) 나무판을 측정하지 않음, (C) 지붕을 칠하지 않음, (D) 공구상자를 운반하지 않음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "The worker is painting the wooden structure.",
      B: "A man is climbing down a ladder.",
      C: "The worker is measuring a piece of wood.",
      D: "A man is assembling a metal frame.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 나무 조각을 측정하고 있음\n" +
      "오답 설명: (A) 나무 구조물을 칠하지 않음, (B) 사다리를 내려오지 않음, (D) 금속 프레임을 조립하지 않음",
  },
  {
    questionNumber: 27,
    choices: {
      A: "The workers are painting a building.",
      B: "Some men are carrying construction materials.",
      C: "The workers are climbing a staircase.",
      D: "The workers are working on scaffolding.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 작업자들이 비계 위에서 작업하고 있음\n" +
      "오답 설명: (A) 건물을 칠하지 않음, (B) 건설 자재를 운반하지 않음, (C) 계단을 오르지 않음",
  },
  {
    questionNumber: 28,
    choices: {
      A: "The workers are repairing a glass window.",
      B: "Some men are painting a metal fence.",
      C: "The workers are climbing down the scaffolding.",
      D: "The workers are assembling scaffolding.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 작업자들이 비계를 조립하고 있음\n" +
      "오답 설명: (A) 유리창을 수리하지 않음, (B) 금속 울타리를 칠하지 않음, (C) 비계를 내려오지 않음",
  },
  {
    questionNumber: 29,
    choices: {
      A: "A mechanic is inspecting a car engine.",
      B: "A mechanic is opening the car hood.",
      C: "A mechanic is cleaning a windshield.",
      D: "A mechanic is filling the gas tank.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 정비사가 자동차 엔진을 점검하고 있음\n" +
      "오답 설명: (B) 후드가 이미 열려있음, (C) 앞유리를 닦지 않음, (D) 주유를 하지 않음",
  },

  {
    questionNumber: 30,
    choices: {
      A: "A mechanic is inspecting the tires.",
      B: "A mechanic is painting a car.",
      C: "A mechanic is working underneath a car.",
      D: "A mechanic is installing a windshield.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 정비사가 차량 하부에서 작업하고 있음\n" +
      "오답 설명: (A) 타이어를 점검하지 않음, (B) 차를 도색하지 않음, (D) 앞유리를 설치하지 않음",
  },

  {
    questionNumber: 31,
    choices: {
      A: "A worker is painting a machine.",
      B: "A worker is installing new pipes.",
      C: "A worker is tightening a bolt with a wrench.",
      D: "A worker is cutting metal parts.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 작업자가 렌치로 볼트를 조이고 있음\n" +
      "오답 설명: (A) 기계를 도색하지 않음, (B) 새 배관을 설치하지 않음, (D) 금속을 자르지 않음",
  },
  {
    questionNumber: 32,
    choices: {
      A: "A worker is cutting metal with a saw.",
      B: "A worker is welding metal parts.",
      C: "A worker is assembling a wooden structure.",
      D: "A worker is painting a steel frame.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 작업자가 금속 부품을 용접하고 있음\n" +
      "오답 설명: (A) 금속을 자르지 않음, (C) 목재 구조물을 조립하지 않음, (D) 철골을 도색하지 않음",
  },
  {
    questionNumber: 33,
    choices: {
      A: "A worker is cutting a wooden board.",
      B: "A worker is using a power drill.",
      C: "A worker is putting on safety goggles.",
      D: "A worker is measuring a piece of wood.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 작업자가 전동 드릴을 사용하고 있음\n" +
      "오답 설명: (A) 목재를 자르지 않음, (C) 이미 보안경을 착용하고 있음, (D) 목재를 측정하지 않음",
  },
  {
    questionNumber: 34,
    choices: {
      A: "The construction is being completed.",
      B: "The construction is in progress.",
      C: "The workers are demolishing a building.",
      D: "The workers are sitting on the roof.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 건설 공사가 진행 중임\n" +
      "오답 설명: (A) 공사가 거의 완료되었다는 의미이므로 부적절함, (C) 건물을 철거하는 것이 아님, (D) 작업자들이 지붕에 앉아있지 않음",
  },
  {
    questionNumber: 35,
    choices: {
      A: "The man is typing on a keyboard.",
      B: "The man is watching a video on his computer.",
      C: "The computer has been taken apart.",
      D: "The man is packing up his laptop.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 컴퓨터가 분해되어 있음\n" +
      "오답 설명: (A) 키보드를 사용하고 있지 않음, (B) 영상을 시청하는 장면이 아님, (D) 노트북이 아니라 데스크톱 부품을 다루고 있음",
  },
  {
    questionNumber: 36,
    choices: {
      A: "The man is standing and using a drill.",
      B: "The man is sitting on the floor.",
      C: "The man is kneeling on one knee.",
      D: "The man is carrying a toolbox.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 한쪽 무릎을 꿇고 있음\n" +
      "오답 설명: (A) 서 있지 않고 무릎을 꿇고 있음, (B) 바닥에 앉아 있는 것이 아니라 한쪽 무릎을 꿇고 있음, (D) 공구함을 들고 있는 것이 아니라 드릴을 사용하고 있음",
  },
  {
    questionNumber: 37,
    choices: {
      A: "The men are painting the walls.",
      B: "The men are assembling furniture.",
      C: "The men are carrying heavy boxes.",
      D: "The men are sitting on the floor.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자들이 가구를 조립하고 있음\n" +
      "오답 설명: (A) 벽을 칠하지 않음, (C) 무거운 상자를 나르지 않음, (D) 바닥에 앉아있지 않음",
  },
  {
    questionNumber: 38,
    choices: {
      A: "The woman is watching a painting tutorial.",
      B: "The wall painting is unfinished.",
      C: "The woman is cleaning the floor.",
      D: "The woman is dipping a brush into the paint.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 벽 페인트칠이 완료되지 않은 상태임\n" +
      "오답 설명: (A) 페인트 튜토리얼 영상을 보고 있지 않음, (C) 바닥을 청소하는 것이 아니라 벽을 칠하고 있음, (D) 붓을 페인트에 담그는 것이 아니라 벽을 칠하고 있음",
  },
];
